import { include } from '../../doc/app/App';

include({
    name: 'InboxConfigProvider',
    doc: require('./doc.md'),
    examples: [
        {
            name: 'Example In-App Notifications',
            import: require('./example.src'),
        },
    ],
});
